export enum LightType {
  Ambient = 'AmbientLight',
  Directional = 'DirectionalLight',
  Hemisphere = 'HemisphereLight',
  Point = 'PointLight',
  RectArea = 'RectAreaLight',
  Spot = 'SpotLight'
}
